import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './App.scss';
import './styles/styles-theme.scss';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // eslint-disable-next-line react-hooks/exhaustive-deps
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
reportWebVitals();
